// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1m32V","selected":"Chip_selected__1KB7P"};